import { Image } from '@ds';
import { GroupUrl } from '@icons';

export const NoContacts = () => {
  return (
    <div className="w-80 h-28 bg-base-80 rounded-2xl flex flex-col items-center justify-center text-m-m text-base-30">
      <Image src={GroupUrl} />
      No Assigned Contacts
    </div>
  );
};
